import JsonApiParser from '../parser/json-api-parser';

export default function (response) {
    if (response === undefined) return;

    var contentType = response.headers['content-type'];
    if (contentType == undefined) return response.data;
    if (contentType.includes('application/vnd.api+json')) return new JsonApiParser(response.data).parse();else return response.data;
}